<template>
  <div class="guide-modal">
    <button class="guide-modal__close" type="button" @click="handleClose">
      <i data-lucide="x"></i>
    </button>

    <h3 class="guide-modal__title">{{ $t("login.howToUseGoogleCode") }}</h3>
    <p class="guide-modal__intro">
      {{ $t("login.codegoogleModule.intro") }}
    </p>

    <div class="guide-modal__sections">
      <section class="guide-section">
        <div class="guide-section__title">
          <div class="guide-section__bar guide-section__bar--blue"></div>
          <span>初始设置（绑定账户）</span>
        </div>

        <div class="guide-section__grid guide-section__grid--three">
          <article class="guide-card">
            <div class="guide-card__head">
              <span class="guide-card__index guide-card__index--blue">01</span>
              <div>
                <h4 class="guide-card__name">选择并打开身份验证器</h4>
                <p class="guide-card__text">
                  在微信搜索“腾讯身份验证器”或“宁盾令牌”等小程序，或下载安装验证器App。
                </p>
              </div>
            </div>
            <div class="guide-card__visual guide-card__visual--short">
              <div class="guide-app">
                <div class="guide-app__icon">
                  <i data-lucide="shield-check"></i>
                </div>
                <div class="guide-app__body">
                  <span class="guide-app__name">宁盾令牌</span>
                  <span class="guide-app__desc">身份验证工具</span>
                </div>
                <span class="guide-app__tag">获取</span>
              </div>
            </div>
          </article>

          <article class="guide-card">
            <div class="guide-card__head">
              <span class="guide-card__index guide-card__index--blue">02</span>
              <div>
                <h4 class="guide-card__name">扫描二维码或输入激活码</h4>
                <p class="guide-card__text">
                  打开身份验证器，扫描绑定界面的二维码或手动输入激活码进行添加。
                </p>
              </div>
            </div>
            <div class="guide-card__visual guide-card__visual--short">
              <div class="guide-alt">
                <div class="guide-alt__scan">
                  <i data-lucide="scan" class="guide-alt__scan-icon"></i>
                  <div class="guide-alt__scan-bar"></div>
                  <div class="guide-alt__scan-line"></div>
                </div>
                <div class="guide-alt__or">或</div>
                <div class="guide-alt__code">****</div>
              </div>
            </div>
          </article>

          <article class="guide-card">
            <div class="guide-card__head">
              <span class="guide-card__index guide-card__index--blue">03</span>
              <div>
                <h4 class="guide-card__name">输入动态数字完成绑定</h4>
                <p class="guide-card__text">
                  将身份验证器中生成的6位动态数字输入到绑定框中，点击绑定按钮。
                </p>
              </div>
            </div>
            <div class="guide-card__visual guide-card__visual--short">
              <div class="guide-bind-demo">
                <div class="guide-bind-demo__input">******</div>
                <div class="guide-bind-demo__button">绑定</div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="guide-section">
        <div class="guide-section__title">
          <div class="guide-section__bar guide-section__bar--violet"></div>
          <span>日常登录（使用验证码）</span>
        </div>

        <div class="guide-section__grid guide-section__grid--two">
          <article class="guide-card">
            <div class="guide-card__head">
              <span class="guide-card__index guide-card__index--violet"
                >01</span
              >
              <div>
                <h4 class="guide-card__name">打开已绑定的身份验证器</h4>
                <p class="guide-card__text guide-card__text--ellipsis">
                  日常登录时，打开手机上已绑定的身份验证器。
                </p>
              </div>
            </div>
            <div class="guide-card__visual guide-card__visual--tall">
              <div class="guide-token">
                <div class="guide-token__top">
                  <span>Graphchain</span>
                  <i
                    data-lucide="more-horizontal"
                    class="guide-token__more"
                  ></i>
                </div>
                <div class="guide-token__code">
                  603902
                  <i data-lucide="copy" class="guide-token__copy"></i>
                </div>
                <div class="guide-token__progress">
                  <div class="guide-token__progress-bar"></div>
                </div>
              </div>
            </div>
          </article>

          <article class="guide-card">
            <div class="guide-card__head">
              <span class="guide-card__index guide-card__index--violet"
                >02</span
              >
              <div>
                <h4 class="guide-card__name">将动态数字输入验证码框中</h4>
                <p class="guide-card__text guide-card__text--ellipsis">
                  将当前显示的6位动态数字填入登录界面的验证码框中即可。
                </p>
              </div>
            </div>
            <div class="guide-card__visual guide-card__visual--tall">
              <div class="guide-login-demo">
                <div class="guide-login-demo__input">
                  <span>60390</span
                  ><span class="guide-login-demo__caret">|</span>
                </div>
                <div class="guide-login-demo__button">登录</div>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "CodeGoogleGuide",
  props: ["googleform", "handleClose3"],
  mounted() {
    this.reloadIcons();
  },
  updated() {
    this.reloadIcons();
  },
  methods: {
    handleClose() {
      if (typeof this.handleClose3 === "function") {
        this.handleClose3();
      }
    },
    reloadIcons() {
      this.$nextTick(() => {
        if (window.lucide) {
          window.lucide.createIcons({ attrs: { "stroke-width": "1.8" } });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.guide-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-family: "General Sans", "PingFang SC", "Microsoft YaHei", system-ui,
    sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  text-rendering: geometricPrecision;
}

.guide-modal__close {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 2;
  padding: 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.guide-modal__close i {
  width: 20px;
  height: 20px;
}

.guide-modal__close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.guide-modal__title {
  margin: 0 0 32px;
  color: #fff;
  font-size: 20px;
  line-height: 28px;
  font-weight: 800;
  flex-shrink: 0;
}

.guide-modal__intro {
  margin: 0 0 24px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.6;
  flex-shrink: 0;
}

.guide-modal__sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.guide-section__title {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 15px;
  line-height: 22px;
  font-weight: 800;
}

.guide-section__title span {
  font-weight: 800;
}

.guide-section__bar {
  width: 4px;
  height: 12px;
  border-radius: 999px;
}

.guide-section__bar--blue {
  background: #3b82f6;
}

.guide-section__bar--violet {
  background: #8b5cf6;
}

.guide-section__grid {
  display: grid;
  gap: 16px;
}

.guide-section__grid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.guide-section__grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.guide-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;
  background: rgba(10, 15, 29, 0.6);
}

.guide-card__head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.guide-card__index {
  margin-top: -2px;
  flex: 0 0 40px;
  white-space: nowrap;
  font-size: 28px;
  line-height: 1;
  font-weight: 900;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.guide-card__index--blue {
  color: rgba(59, 130, 246, 0.7);
}

.guide-card__index--violet {
  color: rgba(139, 92, 246, 0.7);
}

.guide-card__name {
  margin: 0 0 4px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  font-weight: 800;
}

.guide-card__text {
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.6;
}

.guide-card__text--ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.guide-card__visual {
  margin-top: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
}

.guide-card__visual--short {
  height: 100px;
}

.guide-card__visual--tall {
  height: 140px;
}

.guide-app {
  width: 85%;
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.28);
}

.guide-app__icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.guide-app__icon i {
  width: 20px;
  height: 20px;
}

.guide-app__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.guide-app__name {
  color: #fff;
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}

.guide-app__desc {
  color: #94a3b8;
  font-size: 11px;
  line-height: 16px;
}

.guide-app__tag {
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 11px;
  line-height: 1;
  font-weight: 500;
}

.guide-alt {
  display: flex;
  align-items: center;
  gap: 16px;
}

.guide-alt__scan {
  position: relative;
  width: 64px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
}

.guide-alt__scan-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
  color: rgba(255, 255, 255, 0.2);
}

.guide-alt__scan-bar {
  width: 32px;
  height: 2px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
}

.guide-alt__scan-line {
  position: absolute;
  top: 12px;
  width: 80%;
  height: 1px;
  background: rgba(59, 130, 246, 0.8);
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.8);
  animation: guide-scan 2s ease-in-out infinite alternate;
}

.guide-alt__or {
  color: rgba(255, 255, 255, 0.2);
  font-size: 12px;
}

.guide-alt__code {
  width: 80px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  letter-spacing: 0.3em;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.guide-bind-demo {
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.guide-bind-demo__input {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.4);
  color: #94a3b8;
  font-size: 14px;
  letter-spacing: 0.2em;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.guide-bind-demo__button,
.guide-login-demo__button {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  box-shadow: 0 10px 18px rgba(59, 130, 246, 0.2);
}

.guide-token {
  width: 85%;
  height: 104px;
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  background: #1a1d2e;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.28);
}

.guide-token__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0.6;
  color: #fff;
  font-size: 10px;
  line-height: 1;
  font-weight: 500;
}

.guide-token__more,
.guide-token__copy {
  width: 12px;
  height: 12px;
}

.guide-token__code {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #56719e;
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.14em;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.guide-token__copy {
  color: rgba(255, 255, 255, 0.2);
}

.guide-token__progress {
  width: 100%;
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
}

.guide-token__progress-bar {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  background: rgba(86, 113, 158, 0.3);
  animation: guide-progress 30s linear infinite;
}

.guide-login-demo {
  width: 85%;
  height: 104px;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.28);
}

.guide-login-demo__input {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(59, 130, 246, 0.5);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  font-size: 16px;
  line-height: 1;
  letter-spacing: 0.14em;
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
}

.guide-login-demo__caret {
  animation: guide-blink 1s step-start infinite;
}

@keyframes guide-scan {
  0% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(30px);
  }
}

@keyframes guide-progress {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

@keyframes guide-blink {
  50% {
    opacity: 0;
  }
}

@media (max-width: 900px) {
  .guide-section__grid--three,
  .guide-section__grid--two {
    grid-template-columns: 1fr;
  }
}
</style>
